<template>
    <v-container fluid>
        <v-flex md12>
            <v-tabs
                    v-model="tab"
                    slot="extension"
                    color="primary"
                    align-with-title
                    dark
            >
                <v-tabs-slider color="white"></v-tabs-slider>
                <v-tab>
                    Μύνημα Προσφοράς
                </v-tab>
                <v-tab>
                    Μύνημα Παραγγελίας
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card>
                        <v-toolbar color="secondary" dark card>
                            <v-toolbar-title>Επεξεργασία μυνήματος Παραγγελίας</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>

                            <v-container fluid grid-list-xl>
                                <v-layout row>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                                label="Θέμα"
                                                placeholder="Τό θέμα του μυνήματος π.χ.: Χριστουγεννιάτικες Προσφορές. "
                                                v-model="subject"
                                        ></v-text-field>
                                        <v-text-field
                                                label="Όνομα Αποστολέα"
                                                placeholder="Το όνομα που θα εμφανίζεται σαν αποστολέας στο μύνημα πχ Adampharm"
                                                v-model="sender"
                                        ></v-text-field>

                                        <editor v-model="template" :init="init">
                                        </editor>
                                        <h4> Οι κωδικοί συντομίας που θα αντικαταστηθούν στο τελικό μύνημα: </h4>
                                        <v-divider></v-divider>
                                        <ul>
                                            <li> [link] : σύνδεσμος προσφοράς</li>
                                            <li> [date-apo] : ημερομηνία Έναρξης</li>
                                            <li> [date-ews] : ημερομηνία Λήξης</li>
                                            <li> [name] : Όνομα της προσφοράς</li>
                                        </ul>

                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <div class="ma-2 pa-2" style="border:solid black 1px">
                                            <strong> Θέμα: </strong><span v-html="subjectPreview"></span>
                                            <br>
                                            <strong> Αποστολέας: </strong><span v-html="sender"></span>
                                        </div>
                                        <div class="ma-2 pa-2" style="border:solid black 1px">
                                            <span v-html="preview"></span>
                                        </div>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="light-green" dark round @click="saveOfferTemplate()"> Αποθήκευση</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card>
                        <v-toolbar color="secondary" dark card>
                            <v-toolbar-title>Επεξεργασία μυνήματος προσφοράς</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>

                            <v-container fluid grid-list-xl>
                                <v-layout row>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                                label="Θέμα"
                                                placeholder="Τό θέμα του μυνήματος π.χ.: Χριστουγεννιάτικες Προσφορές. "
                                                v-model="invoiceSubject"
                                        ></v-text-field>
                                        <v-text-field
                                                label="Όνομα Αποστολέα"
                                                placeholder="Το όνομα που θα εμφανίζεται σαν αποστολέας στο μύνημα πχ Adampharm"
                                                v-model="invoiceSender"
                                        ></v-text-field>
                                        <editor v-model="invoiceTemplate" :init="init">
                                        </editor>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <div class="ma-2 pa-2" style="border:solid black 1px">
                                            <strong> Θέμα: </strong><span v-html="invoiceSubject"></span>
                                            <br>
                                            <strong> Αποστολέας: </strong><span v-html="invoiceSender"></span>
                                        </div>
                                        <div class="ma-2 pa-2" style="border:solid black 1px">
                                            <span v-html="invoiceTemplate"></span>
                                        </div>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="light-green" dark round @click="saveInvoiceTemplate()"> Αποθήκευση</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>

        </v-flex>
        <v-flex md12>
            <h4> εικόνες: </h4>
            <v-divider></v-divider>
            <img height="40" src="https://www.pharm.gr/wp-content/uploads/2018/11/logo.jpg">
        </v-flex>
        <notifications group="messages" position="bottom right" width="300px"/>

    </v-container>


</template>

<script>
    import Editor from '@tinymce/tinymce-vue';
    import ApiData from "../assets/ApiData";
    import StoreState from "../assets/StoreState";

    export default {
        data: () => ({
            init: {
                selector: 'textarea',  // change this value according to your HTML
                height: 300,
                entity_encoding: 'raw',
                plugins: ['textcolor','table','lists'],
                table_toolbar: '  tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                toolbar: ['undo redo | forecolor backcolor | styleselect | bold italic | link image | alignleft aligncenter alignright | table | numlist bullist'],
                branding: false,
                browser_spellcheck: true
            },
            tab: null,
            subject: "",
            sender: "",
            template: "",
            preview: "",
            subjectPreview:"",
            link: "<a href='{{url-token}}'> Προσφορά </a>",
            dateFrom:"{{date-apo}}",
            dateTo:"{{date-ews}}",
            offerName:"{{name}}",
            invoiceSubject: "",
            invoiceSender: "",
            invoiceTemplate: ""
        }),
        name: "EmailTemplate",
        mounted() {
            StoreState.messages.isLoading = true;
            StoreState.getB2bSettings().then(resp => {
                console.log(StoreState.b2b.settings);
                this.template = StoreState.b2b.settings.OfferTemplate;
                this.template = this.reverseCombine();
                this.subject = StoreState.b2b.settings.OfferSubject;
                this.subject = this.reverseCombineSubject();
                this.sender = StoreState.b2b.settings.OfferSender;

                this.invoiceTemplate = StoreState.b2b.settings.InvoiceTemplate || "";
                this.invoiceSubject = StoreState.b2b.settings.InvoiceSubject || "";
                this.invoiceSender = StoreState.b2b.settings.InvoiceSender || "";
                StoreState.messages.isLoading = false;
            });
        },
        watch: {
            template: function (newValue) {
                this.template = newValue;
                this.preview = this.combine();
            },
            subject: function (newValue) {
                this.subject = newValue;
                this.subjectPreview = this.combineSubject();
            }

        }
        ,
        methods: {
            messages(item, index) {
                let arr = ['Θεμα', 'Αποστολέας', 'Μύνημα'];
                this.$notify({
                    title: arr[index],
                    group: 'messages',
                    type: item ? 'success' : 'error',
                    text: item ? 'Αποθηκεύτηκε' : 'Υπήρξε κάποιο πρόβλημα στην αποθήκευση.'
                })
            },
            combineSubject(){
              return this.subject.replace("[link]", this.link)
                .replace("[date-apo]", this.dateFrom)
                .replace("[date-ews]",this.dateTo)
                .replace('[name]',this.offerName)
            },
            reverseCombineSubject(){
              return this.subject.replace(this.link, '[link]')
                .replace(this.dateFrom,'[date-apo]')
                .replace(this.dateTo,'[date-ews]')
                .replace(this.offerName,'[name]')
            },
            combine() {
                return this.template.replace("[link]", this.link)
                  .replace("[date-apo]", this.dateFrom)
                  .replace("[date-ews]",this.dateTo)
                  .replace('[name]',this.offerName)
            },

            reverseCombine() {
                return this.template.replace(this.link, '[link]')
                  .replace(this.dateFrom,'[date-apo]')
                  .replace(this.dateTo,'[date-ews]')
                  .replace(this.offerName,'[name]')
            },

            saveInvoiceTemplate() {
                StoreState.messages.isLoading = true;
                Promise.all([
                    ApiData.postSetting('InvoiceSubject', this.invoiceSubject),
                    ApiData.postSetting('InvoiceSender', this.invoiceSender),
                    ApiData.postSetting('InvoiceTemplate', this.invoiceTemplate)
                ]).then(
                    resp => {
                        resp.forEach((item, index) => {
                            this.messages(item)
                        });
                        StoreState.messages.isLoading = false;
                    }
                );
            },

            saveOfferTemplate() {
                StoreState.messages.isLoading = true;
                Promise.all([
                    ApiData.postSetting('OfferSubject', this.combineSubject()),
                    ApiData.postSetting('OfferSender', this.sender),
                    ApiData.postSetting('OfferTemplate', this.combine())
                ]).then(
                    resp => {
                        resp.forEach((item, index) => {
                            this.messages(item)
                        });

                        StoreState.messages.isLoading = false;
                    }
                );

            }
        },
        components: {Editor}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/EmailTemplate.vue